import { render, staticRenderFns } from "./Conferences.vue?vue&type=template&id=e53c108a&"
import script from "./Conferences.vue?vue&type=script&lang=js&"
export * from "./Conferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports